<div class="layout">
  <app-header class="header"></app-header>

  <div class="body">
    <app-sidebar
      class="sidebar"
    ></app-sidebar>

    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
